/** 登录路由 */

// 入口页
const index = () => import(/* webpackChunkName: "Index" */ '@/views/loginModule/index')
const notPermission = () => import(/* webpackChunkName: "Index" */ '@/views/notPermission')
// 登录
const Login = () => import(/* webpackChunkName: "Login" */ '@/views/loginModule/login')
const loginRouter = [
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/App.vue')
  },
  {
    path: '/notPermission',
    name: 'notPermission',
    component: notPermission
  },
  {
    path: '/index',
    name: 'index',
    redirect: '/admin/home',
    component: index
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '首页'
    }
  }
]
export default loginRouter
